class HeyNoviProductForm {
  constructor(root) {
    this.root = root;
    this.form = root.querySelector('[data-product-form]');
    this.variants = JSON.parse(document.querySelector('[data-product-variants]')?.textContent || '[]');
    this.variantInput = root.querySelector('[data-variant-id]');
    this.price = root.querySelector('[data-variant-price]');
    this.button = root.querySelector('[data-add-button]');
    root.querySelectorAll('[data-option-value]').forEach((input) => input.addEventListener('change', () => this.updateVariant()));
  }

  updateVariant() {
    const values = [...this.root.querySelectorAll('[data-option-index]')].map((group) => group.querySelector('[data-option-value]:checked')?.value);
    const variant = this.variants.find((item) => item.options.every((value, index) => value === values[index]));
    if (!variant) return;
    this.variantInput.value = variant.id;
    this.price.textContent = this.formatMoney(variant.price);
    this.button.disabled = !variant.available;
    this.button.querySelector('[data-add-button-label]').textContent = variant.available ? this.button.dataset.availableLabel : 'Nicht verfügbar';
    window.history.replaceState({}, '', `${window.location.pathname}?variant=${variant.id}`);
  }

  formatMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(cents / 100);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-form-root]').forEach((root) => {
    const component = new HeyNoviProductForm(root);
    if (component.button) component.button.dataset.availableLabel = component.button.querySelector('[data-add-button-label]').textContent;
  });
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const slides = gallery.querySelectorAll('[data-gallery-slide]');
    const thumbnails = gallery.querySelectorAll('[data-gallery-thumbnail]');
    thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', () => {
      const index = thumbnail.dataset.galleryThumbnail;
      slides.forEach((slide) => slide.classList.toggle('is-active', slide.dataset.gallerySlide === index));
      thumbnails.forEach((item) => { const active = item === thumbnail; item.classList.toggle('is-active', active); item.setAttribute('aria-current', active ? 'true' : 'false'); });
    }));
  });
});
